<app-default-layout>
    <div class="h-full flex flex-col items-center justify-center gap-y-4 px-4 text-center">

        <span class="text-[12rem] font-bold leading-none text-white/10 select-none">404</span>

        <div class="-mt-4 flex flex-col items-center gap-y-5">
            <h1 class="text-2xl font-semibold text-white">Page not found</h1>
            <p class="text-white/50 max-w-sm text-sm">
                The venue you're looking for doesn't exist or is no longer available.
            </p>
        </div>

    </div>
</app-default-layout>